import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-claim-worksheet',
  templateUrl: './claim-worksheet.component.html',
  styleUrls: ['./claim-worksheet.component.scss']
})
export class ClaimWorksheetComponent implements OnInit {

  @Input() IO: any;
  @Input() transactionState: any;

  constructor() { }

  ngOnInit() {
  }

  profilePanel

}
